import styled from 'styled-components/macro'

const StyledIconWrapper = styled.span`
  margin-right: 8px;
`

export default StyledIconWrapper
